<template>
  <div>
    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.consumption"> mdi-home</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.consumption") }}: <b>{{ format(data.load) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.inverter"> mdi-home-battery</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.inverterTotal") }}: <b>{{ format(data.inverterTotal) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.fromGrid"> mdi-transmission-tower-import</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.buy") }}: <b>{{ format(data.grid) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.toGrid"> mdi-transmission-tower-export</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.sell") }}: <b>{{ format(data.gridOverflows) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.fve"> mdi-solar-power</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.fve") }}: <b>{{ format(data.pv) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.discharging">mdi-battery-50</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.discharged") }}: <b>{{ format(data.bat) }} </b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3" md="2">
        <v-icon class="ml-2" :color="colors.charging">mdi-battery-charging-50</v-icon>
      </v-col>
      <v-col cols="9" md="10">
        {{ $t("donut.charged") }}: <b>{{ format(data.batCharged) }} </b>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "charts_DonutCharts_InfoPanel",
  props: {
    data: {
      type: Object,
      require: false,
      default: null,
    },
    colors: {
      type: Object,
      require: false,
      default: null,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},

  computed: {},
  methods: {
    format(value) {
      if (value >= 1000) {
        return (value / 1000).toFixed(3) + " MWh";
      } else {
        return value + " kWh";
      }
    },
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
